"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PiiType = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var PiiType;
(function (PiiType) {
    PiiType["AwsAccessKey"] = "AWS_ACCESS_KEY";
    PiiType["AwsSecretKey"] = "AWS_SECRET_KEY";
    PiiType["BankAccountNumber"] = "BANK_ACCOUNT_NUMBER";
    PiiType["BankRouting"] = "BANK_ROUTING";
    PiiType["CaHealthNumber"] = "CA_HEALTH_NUMBER";
    PiiType["CaSocialInsuranceNumber"] = "CA_SOCIAL_INSURANCE_NUMBER";
    PiiType["CreditDebitNumber"] = "CREDIT_DEBIT_NUMBER";
    PiiType["DriverId"] = "DRIVER_ID";
    PiiType["Email"] = "EMAIL";
    PiiType["InAadhaar"] = "IN_AADHAAR";
    PiiType["InNrega"] = "IN_NREGA";
    PiiType["InPermanentAccountNumber"] = "IN_PERMANENT_ACCOUNT_NUMBER";
    PiiType["InVoterNumber"] = "IN_VOTER_NUMBER";
    PiiType["InternationalBankAccountNumber"] = "INTERNATIONAL_BANK_ACCOUNT_NUMBER";
    PiiType["PassportNumber"] = "PASSPORT_NUMBER";
    PiiType["Password"] = "PASSWORD";
    PiiType["Phone"] = "PHONE";
    PiiType["Ssn"] = "SSN";
    PiiType["SwiftCode"] = "SWIFT_CODE";
    PiiType["UkNationalHealthServiceNumber"] = "UK_NATIONAL_HEALTH_SERVICE_NUMBER";
    PiiType["UkNationalInsuranceNumber"] = "UK_NATIONAL_INSURANCE_NUMBER";
    PiiType["UkUniqueTaxpayerReferenceNumber"] = "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER";
    PiiType["Username"] = "USERNAME";
    PiiType["UsIndividualTaxIdentificationNumber"] = "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER";
    PiiType["VehicleIdentificationNumber"] = "VEHICLE_IDENTIFICATION_NUMBER";
    PiiType["IpAddress"] = "IP_ADDRESS";
})(PiiType = exports.PiiType || (exports.PiiType = {}));
